import { fireworkScore } from "./fireworkScore";
import { blessingTiming } from "./blessingTiming";

// 21 years, 21 seconds from the first blossom to the last fading ember.
// Candle breathing room and the lettering that follows are outside this span.
export const FIREWORK_SHOW_DURATION = 21;
export const BLESSING_SHOW_DURATION = blessingTiming.total;
const firstBurst = fireworkScore[0].at;
const fireworksEnd = firstBurst + FIREWORK_SHOW_DURATION;
const reformStarts = fireworksEnd + BLESSING_SHOW_DURATION;
export const celebrationTimeline = {
  firstBurst,
  lastBurst: fireworkScore[fireworkScore.length - 1].at,
  fireworksEnd,
  blessingsStart: fireworksEnd,
  reformStarts,
  reformEnds: reformStarts + 3,
  finaleReady: reformStarts + 3.15,
  total: reformStarts + 3.3,
} as const;

// Firework particles are fully transparent here; omit their draw/compute work
// while the DOM wishes play. The moving night environment remains active.
export function isBlessingInterval(elapsed: number) {
  return elapsed >= celebrationTimeline.blessingsStart && elapsed < celebrationTimeline.reformStarts;
}

export function getCelebrationProgress(elapsed: number) {
  return Math.min(1, Math.max(0, elapsed / celebrationTimeline.total));
}
